import { render, staticRenderFns } from "./DedupSearchForm.vue?vue&type=template&id=b5cb0daa&scoped=true"
import script from "./DedupSearchForm.vue?vue&type=script&lang=js"
export * from "./DedupSearchForm.vue?vue&type=script&lang=js"
import style0 from "./DedupSearchForm.vue?vue&type=style&index=0&id=b5cb0daa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cb0daa",
  null
  
)

export default component.exports